<div
  class="sky-character"
  data-testid="sky-character"
  [attr.data-pose]="pose"
  [attr.data-animation-mode]="animationMode"
  [attr.data-one-shot]="oneShot"
  [attr.data-audio-status]="audioStatus">
  @if (imageUrl) {
    <img
      class="sky-character-still"
      [class.sky-character-still-hidden]="showAnimation"
      [src]="imageUrl"
      alt=""
      loading="lazy" />
  }
  <div
    #lottieHost
    class="sky-character-lottie"
    [class.sky-character-lottie-visible]="showAnimation"
    aria-hidden="true"></div>
  @if (audioStatus === 'blocked') {
    <button
      type="button"
      class="sky-character-sound-button"
      aria-label="Replay Sky with sound"
      title="Play sound"
      (click)="replayWithSound($event)">
      <i class="bi bi-volume-up-fill" aria-hidden="true"></i>
      <span>Play sound</span>
    </button>
  }
</div>
